<template>
  <div>
    <h1 class="text-success">Formulario Clasificación Por Período de Edad de Niños/as</h1>
    <div class="alert alert-info" role="alert">
      <strong>Nota:</strong> Este formulario agregará la clasificación de Esquemas de vacunación niños/as .
    </div>
    <div class="mt-4">
      <button @click="showCreateForm" class="btn btn-primary">Agregar Clasificación</button>
    </div>

    <!-- Lista de VacunaClasificacionNiño en una tabla -->
    <div class="table-responsive mt-3">
      <table class="table table-bordered">
        <thead class="thead-light">
          <tr>
            <th>Clasificación por edad para niños/as</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="vacunaClasificacionNiño in vacunaClasificacionNiñoList" :key="vacunaClasificacionNiño._id">
            <td>{{ vacunaClasificacionNiño.nombre }}</td>
            <td>
              <div class="btn-group" role="group">
                <button @click="editVacunaClasificacionNiño(vacunaClasificacionNiño)" class="btn btn-warning btn-sm">Editar</button>
                <button @click="deleteVacunaClasificacionNiño(vacunaClasificacionNiño._id)" class="btn btn-danger btn-sm">Eliminar</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Formulario de creación/editar -->
    <div v-if="showForm" class="mt-4">
      <h2 class="h4">{{ isEditing ? 'Editar VacunaClasificacionNiño' : 'Agregar VacunaClasificacionNiño' }}</h2>
      <form @submit.prevent="isEditing ? updateVacunaClasificacionNiño() : createVacunaClasificacionNiño()" class="form-inline">
        <div class="form-group mr-2">
          <label for="nombre" class="mr-2">Nombre</label>
          <input v-model="formData.nombre" type="text" id="nombre" required class="form-control form-control-lg" />
        </div>
        <div class="btn-group">
          <button type="submit" class="btn btn-primary">{{ isEditing ? 'Guardar Cambios' : 'Agregar' }}</button>
          <button @click="cancelEdit" class="btn btn-secondary">Cancelar</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert';
import { BASE_URL } from '../store/config';

export default {
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  data() {
    return {
      vacunaClasificacionNiñoList: [],
      showForm: false,
      formData: {
        nombre: '',
      },
      isEditing: false,
      editingVacunaClasificacionNiñoId: null,
    };
  },
  methods: {
    async fetchVacunaClasificacionNiño() {
      try {
        const response = await axios.get(`${BASE_URL}/api/vacunaclasificacionninio`, {
          headers: {
            'x-access-token': this.$store.state.auth.user.accessToken,
          },
        });
        this.vacunaClasificacionNiñoList = response.data;
      } catch (error) {
        console.error('Error al obtener VacunaClasificacionNiño:', error);
      }
    },
    showCreateForm() {
      this.showForm = true;
      this.isEditing = false;
      this.formData = {
        nombre: '',
      };
    },
    async createVacunaClasificacionNiño() {
      try {
        await axios.post(`${BASE_URL}/api/vacunaclasificacionninio`, this.formData, {
          headers: {
            'x-access-token': this.$store.state.auth.user.accessToken,
          },
        });
        swal({
          title: '¡Información Guardada!',
          text: 'La información de VacunaClasificacionNiño ha sido guardada correctamente.',
          icon: 'success',
          button: 'OK',
        });
        this.clearFields();
        this.fetchVacunaClasificacionNiño();
        this.showForm = false;
      } catch (error) {
        swal({
          title: 'Error',
          text: `Hubo un error al guardar la información de VacunaClasificacionNiño. \n ${error.response.data.message}.`,
          icon: 'error',
          button: 'OK',
        });
      }
    },
    clearFields() {
      this.formData = {
        nombre: '',
      };
    },
    deleteVacunaClasificacionNiño(id) {
      swal({
        title: '¿Estás seguro?',
        text: 'Una vez eliminado, no podrás recuperar este registro.',
        icon: 'warning',
        buttons: ['Cancelar', 'Eliminar'],
        dangerMode: true,
      })
      .then((confirmation) => {
        if (confirmation) {
          this.performVacunaClasificacionNiñoDeletion(id);
        }
      });
    },
    async performVacunaClasificacionNiñoDeletion(id) {
      try {
        await axios.delete(`${BASE_URL}/api/vacunaclasificacionninio/${id}`, {
          headers: {
            'x-access-token': this.$store.state.auth.user.accessToken,
          },
        });
        swal({
          title: '¡Información Eliminada!',
          text: 'La información de VacunaClasificacionNiño ha sido eliminada correctamente.',
          icon: 'success',
          button: 'OK',
        });
        this.fetchVacunaClasificacionNiño();
      } catch (error) {
        swal({
          title: 'Error',
          text: 'Hubo un error al eliminar la información de VacunaClasificacionNiño.',
          icon: 'error',
          button: 'OK',
        });
      }
    },
    editVacunaClasificacionNiño(vacunaClasificacionNiño) {
      this.isEditing = true;
      this.editingVacunaClasificacionNiñoId = vacunaClasificacionNiño._id;
      this.formData.nombre = vacunaClasificacionNiño.nombre;
      this.showForm = true;
    },
    async updateVacunaClasificacionNiño() {
      try {
        await axios.put(`${BASE_URL}/api/vacunaclasificacionninio/${this.editingVacunaClasificacionNiñoId}`, this.formData, {
          headers: {
            'x-access-token': this.$store.state.auth.user.accessToken,
          },
        });
        swal({
          title: '¡Información Actualizada!',
          text: 'La información de VacunaClasificacionNiño ha sido actualizada correctamente.',
          icon: 'success',
          button: 'OK',
        });
        this.clearFields();
        this.fetchVacunaClasificacionNiño();
        this.showForm = false;
      } catch (error) {
        swal({
          title: 'Error',
          text: `Hubo un error al editar la información de VacunaClasificacionNiño. \n ${error.response.data.message}.`,
          icon: 'error',
          button: 'OK',
        });
      }
    },
    cancelEdit() {
      this.showForm = false;
      this.isEditing = false;
      this.clearFields();
    },
  },
  mounted() {
    this.fetchVacunaClasificacionNiño();
  },
};
</script>

<style scoped>
/* Estilos adicionales si es necesario */
</style>
